import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { Map } from 'immutable';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {MainInformation} from './detail/main-information';
import ActionsList from './detail/actions-list';
import {DocumentJournal} from './detail/document-journal';

import Box from 'components/box';
import Spinner from 'spinner';
import {PageHead} from 'components/header/components';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import {Modal, CloseModal, ModalContent} from 'components/modal';

import {loadDocumentDetail, loadDocumentJournal, deleteDocument, changeDocumentValue} from 'redux/actions/admin/documents';

import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  document: state.adminDocuments.get('documentItem'),
  isFetching: state.adminDocuments.get('documentsAreLoading'),
  documentJournal: state.adminDocuments.get('documentJournal')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id) => {
    dispatch(loadDocumentDetail(id));
    dispatch(loadDocumentJournal(id))
  },
  deleteDocument: (id) => dispatch(deleteDocument(id)),
  changeValue: (value, key) => dispatch(changeDocumentValue(value, key))
});

class DocumentDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(event) {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.document_id)
  }

  render() {
    if (this.props.document === undefined || this.props.documentJournal === undefined) {
      return <Spinner/>;
    }

    if (this.props.isFetching) {
      return <Spinner />
    }

    const document = this.props.document;

    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/documents/">Документи</Link></li>
              <li><Link to={`/admin/documents/detail/${document.get('id')}`}>{document.get('name')}</Link></li>
          </Breadcrumbs>
        <PageHead>
          <h2>{document.get('name')}</h2>
        </PageHead>

        {!(document.get('current_status') === "archive") ? (
          <Box title4="Дії з документом">
            <ActionsList
              id={this.props.match.params.document_id}
              toggleModal={this.toggleModal}
              changeValue={(value, key) => this.props.changeValue(value, key)}
              document={document}
            />
          </Box>
        ):null}

        <Box title4="Основні дані">
          <MainInformation document={document} />
        </Box>

        <Box title4="Журнал дій">
          {this.props.documentJournal.size > 0 ? (
            <DocumentJournal journal={this.props.documentJournal} />
          ):(
            <div>Дії відсутні</div>
          )}
        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <div>
          <Modal>
            <CloseModal>
              <div>
				         <img src={close} alt="закрити" onClick={this.toggleModal} />
              </div>
						</CloseModal>
            <ModalContent>
              <h3>Ви впевнені, що хочете видалити документ?</h3>

              <ButtonWrap>
                <ButtonSuccessModal onClick={(id) => this.props.deleteDocument(this.props.match.params.document_id)} value="Так"/>
                <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
              </ButtonWrap>
            </ModalContent>
          </Modal>
          </div>

        </ReactModal>
      </div>
    )
  }
}

DocumentDetail.propTypes = {
  document: PropTypes.instanceOf(Map),
  onLoad: PropTypes.func,
  deleteDocument: PropTypes.func,
  isFetching: PropTypes.bool,
  changeValue: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDetail);



// WEBPACK FOOTER //
// ./src/admin/documents/detail.js